<div class="container-fluid confirm_password_container">
	<input type="hidden" id="anPageName" name="page" value="reset-password3" />
	<div class="row">
		<div class="col-12">
			<div class="header">
				<img class="image-11" src="../assets/newimg/image-11-86@2x.png" alt="image 11" />
				<div class="flex-col">
					<div class="overlap-group-1">
						<p class="surname opensans-bold-sapphire-20px">
							<span class="opensans-normal-sapphire-20px">Cross</span>
							<span class="ellipsis"></span>
							<span class="opensans-extra-bold-sapphire-20px">Easy</span>
						</p>
					</div>
					<p class="brought-to-you-by-cr opensans-normal-star-dust-9px">
						<span class="opensans-normal-star-dust-9px">Brought to you by Cross-Border Road and Transport
							Agency</span>
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="row content_row">
		<div class="col-8 reset_form">
			<div class="heading">
				<h1>Resetting password.</h1>
			</div>
			<p class="please-provide-us">
				Please enter your new password and press save. ( Your old
				Password is no longer active. Reset your new
				password. [Requires 8 to 12 characters]
			</p>

			<form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" autocomplete="off">
				<div class="row form_row">
					<div class="col-6">
						<div class="form_field">
							<label class="label" autocomplete="new-npass">Enter new password</label>
							<input style="width: 400px;" type="password" autocomplete="false"
								class="form-field input-sm" formControlName="Password" [ngModel]="loginUser.Password"
								[ngClass]="{'error':(form.controls['Password'].touched && form.controls['Password'].invalid)}"
								#pwd />
							<div class="invalid-feedback"
								*ngIf="form.controls['Password'].touched && form.controls['Password'].invalid">
								{{getPasswordErr()}}
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form_field">
							<label class="label">Re-enter password</label>
							<input type="password" class="form-field input-sm" formControlName="ConfirmPassword"
								name="ConfirmPassword" [ngModel]="loginUser.ConfirmPassword"
								[ngClass]="{'error':(form.controls['ConfirmPassword'].touched && form.controls['ConfirmPassword'].invalid)}"
								(blur)="passwordMatch(pwd.value,cnfPwd.value)" #cnfPwd autocomplete="new-pass" />
							<span class="invalid-feedback"
								*ngIf="form.controls['ConfirmPassword'].touched && form.controls['ConfirmPassword'].invalid">
								{{getConfirmPasswordErr()}}
							</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 primary">
						<div class="save">
							<button type="submit" class="btn btn-outline-warning" [disabled]="!form.valid">Save</button>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="col-4 parent">
			<div class="parents">
				<div class="overlap_group">
					<div class="surname">
						<span class="cross">Cross</span>
						<span class="ellipsis"></span>
						<span class="easy">Easy</span>
						<div class="here-there-everywhere">
							<span class="opensans-normal-white-16px">Here, There, Everywhere</span>
						</div>
					</div>
				</div>
				<div class="convenient-effectiv">
					<p>Convenient, Effective and</p>
					<p>Secure way to apply and</p>
					<p>manage your Permits</p>
					<p>Online</p>
				</div>
			</div>
		</div>
	</div>
</div>